import cx from 'classnames';
import * as animationStyles from '~/common/components/MegaNav/MegaNavVariant/components/HamburgerMenu/components/HamburgerMenuDrawer/Animations.module.scss';
import type {AnimationDirection} from '~/common/components/MegaNav/MegaNavVariant/components/HamburgerMenu/components/HamburgerMenuDrawer/HamburgerMenuDrawer';
import {
  type InvitationCategoryType,
  TabsEnum,
} from '~/common/components/MegaNav/MegaNavVariant/types';
import {CategoryList} from './components/CategoryList/CategoryList';
import {EvitePro} from './components/EvitePro/EvitePro';
import {NavTabs} from './components/NavTabs/NavTabs';

type MainLevelViewProps = {
  categories: InvitationCategoryType[];
  activeTab: TabsEnum;
  onCategoryClick: (category: InvitationCategoryType) => void;
  onTabClick: (tab: TabsEnum) => void;
  animationDirection: AnimationDirection;
  onAnimationEnd: () => void;
};

export const MainLevelView = ({
  categories,
  activeTab,
  onCategoryClick,
  onTabClick,
  animationDirection,
  onAnimationEnd,
}: MainLevelViewProps) => {
  const getAnimationClass = () => {
    switch (animationDirection) {
      case 'slide-left':
        return animationStyles.slideLeftOut;
      case 'slide-right':
        return animationStyles.slideRightIn;
      default:
        return animationStyles.noAnimation;
    }
  };

  return (
    <div
      className={cx(animationStyles.drawerContainer, getAnimationClass())}
      onAnimationEnd={onAnimationEnd}
    >
      <NavTabs activeTab={activeTab} onTabClick={onTabClick} />

      {activeTab === TabsEnum.PRO ? (
        <EvitePro />
      ) : (
        <CategoryList categories={categories} onCategoryClick={onCategoryClick} />
      )}
    </div>
  );
};
